import { render, staticRenderFns } from "./type_list.vue?vue&type=template&id=46793a3e&"
import script from "./type_list.vue?vue&type=script&lang=js&"
export * from "./type_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports